import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { Search, Plus, Mail, Phone, Building2, MoreVertical, CheckCircle2, X, MapPin, ChevronRight } from 'lucide-react';
import { MobileLayout } from '../../components/MobileLayout';
import { useScreenInit } from '../../useScreenInit.js';
import { REFERENTI, TYPE_STYLE } from './referentiData';
export function CmReferentiPage() {
  useScreenInit();
  const navigate = useNavigate();
  const [query, setQuery] = useState('');
  const [isAddOpen, setIsAddOpen] = useState(false);
  const filtered = REFERENTI.filter(r => {
    const full = `${r.firstName} ${r.lastName}`.toLowerCase();
    const q = query.toLowerCase();
    return full.includes(q) || r.email.toLowerCase().includes(q) || r.zone.toLowerCase().includes(q);
  });
  return <MobileLayout data-id="element-2506">
      {/* Header */}
      <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-4 mb-6" data-id="element-2507">
        <div data-id="element-2508">
          <h1 className="text-xl lg:text-2xl font-bold text-navy" data-id="element-2509">Referenti</h1>
        </div>
        <button onClick={() => setIsAddOpen(true)} className="w-full sm:w-auto px-4 py-2.5 bg-coral text-white rounded-xl hover:bg-coral-600 transition-colors text-sm font-medium min-h-[44px] flex items-center justify-center gap-2" data-id="element-2510">
          <Plus size={18} data-id="element-2511" />
          Aggiungi referente
        </button>
      </div>

      {/* Sub-nav between Referenti / Appartamenti */}
      <div className="inline-flex items-center gap-1 bg-gray-100 rounded-lg p-1 mb-6" data-id="element-2512">
        <span className="px-3 py-1.5 rounded-md text-sm font-medium bg-white text-navy shadow-sm" data-id="element-2513">
          Referenti
        </span>
        <Link to="/cm/clienti/appartamenti" className="px-3 py-1.5 rounded-md text-sm font-medium text-gray-500 hover:text-navy transition-colors" data-id="element-2514">
          Appartamenti
        </Link>
      </div>

      {/* Search */}
      <div className="bg-white p-4 rounded-xl border border-border shadow-sm mb-6" data-id="element-2515">
        <div className="relative" data-id="element-2516">
          <Search className="absolute left-3 top-1/2 -translate-y-1/2 text-gray-400" size={18} data-id="element-2517" />
          <input type="text" placeholder="Cerca per nome, email o zona..." value={query} onChange={e => setQuery(e.target.value)} className="w-full pl-10 pr-4 py-2.5 border border-border rounded-lg text-sm focus:ring-2 focus:ring-coral focus:border-transparent outline-none transition-all min-h-[44px]" data-id="element-2518" />
        </div>
      </div>

      {/* Table */}
      <div className="bg-white rounded-xl border border-border shadow-sm overflow-hidden" data-id="element-2519">
        <div className="overflow-x-auto" data-id="element-2520">
          <table className="w-full text-left border-collapse min-w-[760px]" data-id="element-2521">
            <thead data-id="element-2522">
              <tr className="bg-gray-50 border-b border-border" data-id="element-2523">
                <th className="px-4 lg:px-6 py-4 text-xs font-semibold text-gray-500 uppercase tracking-wider" data-id="element-2524">
                  Referente
                </th>
                <th className="px-4 lg:px-6 py-4 text-xs font-semibold text-gray-500 uppercase tracking-wider" data-id="element-2525">
                  Tipologia
                </th>
                <th className="px-4 lg:px-6 py-4 text-xs font-semibold text-gray-500 uppercase tracking-wider" data-id="element-2526">
                  Contatti
                </th>
                <th className="px-4 lg:px-6 py-4 text-xs font-semibold text-gray-500 uppercase tracking-wider" data-id="element-2527">
                  Appartamenti
                </th>
                <th className="px-4 lg:px-6 py-4 text-xs font-semibold text-gray-500 uppercase tracking-wider" data-id="element-2528">
                  Contratto
                </th>
                <th className="px-4 lg:px-6 py-4 text-xs font-semibold text-gray-500 uppercase tracking-wider text-right" data-id="element-2529">
                  Azioni
                </th>
              </tr>
            </thead>
            <tbody className="divide-y divide-border" data-id="element-2530">
              {filtered.map(r => <tr key={r.id} onClick={() => navigate(`/cm/clienti/referenti/${r.id}`)} className="hover:bg-gray-50/50 transition-colors cursor-pointer" data-id="element-2531">
                  <td className="px-4 lg:px-6 py-4" data-id="element-2532">
                    <div className="flex items-center gap-3" data-id="element-2533">
                      <div className="w-10 h-10 rounded-full bg-gray-100 flex items-center justify-center text-navy font-bold flex-shrink-0 text-sm" data-id="element-2534">
                        {r.firstName[0]}
                        {r.lastName[0]}
                      </div>
                      <div className="min-w-0" data-id="element-2535">
                        <div className="text-sm font-semibold text-navy whitespace-nowrap" data-id="element-2536">
                          {r.firstName} {r.lastName}
                        </div>
                        <div className="flex items-center gap-1 text-xs text-gray-500 whitespace-nowrap" data-id="element-2537">
                          <MapPin size={11} className="text-gray-400" data-id="element-2538" />
                          {r.zone}
                        </div>
                      </div>
                    </div>
                  </td>
                  <td className="px-4 lg:px-6 py-4" data-id="element-2539">
                    <span className={`inline-flex items-center px-2.5 py-1 rounded-full text-xs font-medium border whitespace-nowrap ${TYPE_STYLE[r.type]}`} data-id="element-2540">
                      {r.type}
                    </span>
                  </td>
                  <td className="px-4 lg:px-6 py-4" data-id="element-2541">
                    <div className="space-y-1" data-id="element-2542">
                      <div className="flex items-center gap-2 text-sm text-gray-600 whitespace-nowrap" data-id="element-2543">
                        <Mail size={14} className="text-gray-400" data-id="element-2544" />
                        {r.email}
                      </div>
                      <div className="flex items-center gap-2 text-sm text-gray-600 whitespace-nowrap" data-id="element-2545">
                        <Phone size={14} className="text-gray-400" data-id="element-2546" />
                        {r.phone}
                      </div>
                    </div>
                  </td>
                  <td className="px-4 lg:px-6 py-4" data-id="element-2547">
                    <span className="inline-flex items-center gap-1.5 text-sm font-medium text-navy whitespace-nowrap" data-id="element-2548">
                      <Building2 size={14} className="text-gray-400" data-id="element-2549" />
                      {r.apartments}
                    </span>
                  </td>
                  <td className="px-4 lg:px-6 py-4" data-id="element-2550">
                    {r.activeContract ? <span className="inline-flex items-center gap-1.5 px-2.5 py-1 rounded-full text-xs font-medium bg-emerald-50 text-emerald-700 border border-emerald-200 whitespace-nowrap" data-id="element-2551">
                        <CheckCircle2 size={13} data-id="element-2552" />
                        Attivo
                      </span> : <span className="inline-flex items-center px-2.5 py-1 rounded-full text-xs font-medium bg-gray-100 text-gray-500 border border-gray-200 whitespace-nowrap" data-id="element-2553">
                        Nessuno
                      </span>}
                  </td>
                  <td className="px-4 lg:px-6 py-4 text-right" data-id="element-2554">
                    <div className="flex items-center justify-end gap-1" data-id="element-2555">
                      <button onClick={e => e.stopPropagation()} aria-label="Azioni referente" className="p-2 text-gray-400 hover:text-navy rounded-lg hover:bg-gray-100 transition-colors" data-id="element-2556">
                        <MoreVertical size={18} data-id="element-2557" />
                      </button>
                      <ChevronRight size={18} className="text-gray-300 flex-shrink-0" data-id="element-2558" />
                    </div>
                  </td>
                </tr>)}
              {filtered.length === 0 && <tr data-id="element-2559">
                  <td colSpan={6} className="px-6 py-10 text-center text-sm text-gray-500" data-id="element-2560">
                    Nessun referente trovato.
                  </td>
                </tr>}
            </tbody>
          </table>
        </div>
      </div>

      {/* Add Referente Modal */}
      {isAddOpen && <div className="fixed inset-0 bg-black/40 backdrop-blur-sm z-50 flex items-center justify-center p-4" onClick={() => setIsAddOpen(false)} data-id="element-2561">
          <div className="bg-white rounded-2xl shadow-xl w-full max-w-md overflow-hidden flex flex-col max-h-[90vh]" onClick={e => e.stopPropagation()} role="dialog" aria-modal="true" aria-label="Nuovo referente" data-id="element-2562">
            <div className="flex items-center justify-between p-4 border-b border-border" data-id="element-2563">
              <h2 className="text-lg font-bold text-navy" data-id="element-2564">Nuovo referente</h2>
              <button onClick={() => setIsAddOpen(false)} aria-label="Chiudi" className="p-2 hover:bg-gray-100 rounded-full transition-colors" data-id="element-2565">
                <X size={20} className="text-gray-500" data-id="element-2566" />
              </button>
            </div>
            <div className="p-4 overflow-y-auto space-y-4" data-id="element-2567">
              <div className="grid grid-cols-2 gap-4" data-id="element-2568">
                <div data-id="element-2569">
                  <label className="block text-xs font-medium text-gray-500 uppercase tracking-wide mb-1.5" data-id="element-2570">
                    Nome
                  </label>
                  <input type="text" placeholder="Mario" className="w-full px-3 py-2.5 border border-border rounded-lg text-sm focus:ring-2 focus:ring-coral focus:border-transparent outline-none min-h-[44px]" data-id="element-2571" />
                </div>
                <div data-id="element-2572">
                  <label className="block text-xs font-medium text-gray-500 uppercase tracking-wide mb-1.5" data-id="element-2573">
                    Cognome
                  </label>
                  <input type="text" placeholder="Rossi" className="w-full px-3 py-2.5 border border-border rounded-lg text-sm focus:ring-2 focus:ring-coral focus:border-transparent outline-none min-h-[44px]" data-id="element-2574" />
                </div>
              </div>
              <div data-id="element-2575">
                <label className="block text-xs font-medium text-gray-500 uppercase tracking-wide mb-1.5" data-id="element-2576">
                  Tipologia
                </label>
                <select className="w-full px-3 py-2.5 border border-border rounded-lg text-sm focus:ring-2 focus:ring-coral focus:border-transparent outline-none bg-white min-h-[44px]" data-id="element-2577">
                  <option data-id="element-2578">Host</option>
                  <option data-id="element-2579">Property Manager</option>
                  <option data-id="element-2580">B&B</option>
                  <option data-id="element-2581">Agenzia</option>
                </select>
              </div>
              <div data-id="element-2582">
                <label className="block text-xs font-medium text-gray-500 uppercase tracking-wide mb-1.5" data-id="element-2583">
                  Email
                </label>
                <input type="email" placeholder="mario.rossi@example.com" className="w-full px-3 py-2.5 border border-border rounded-lg text-sm focus:ring-2 focus:ring-coral focus:border-transparent outline-none min-h-[44px]" data-id="element-2584" />
              </div>
              <div data-id="element-2585">
                <label className="block text-xs font-medium text-gray-500 uppercase tracking-wide mb-1.5" data-id="element-2586">
                  Telefono
                </label>
                <input type="tel" placeholder="+39 333 1234567" className="w-full px-3 py-2.5 border border-border rounded-lg text-sm focus:ring-2 focus:ring-coral focus:border-transparent outline-none min-h-[44px]" data-id="element-2587" />
              </div>
            </div>
            <div className="p-4 border-t border-border bg-gray-50 flex justify-end gap-3" data-id="element-2588">
              <button onClick={() => setIsAddOpen(false)} className="px-4 py-2.5 bg-white border border-border text-gray-700 rounded-full hover:bg-gray-50 transition-colors text-sm font-medium min-h-[44px]" data-id="element-2589">
                Annulla
              </button>
              <button onClick={() => setIsAddOpen(false)} className="px-6 py-2.5 bg-coral text-white rounded-xl hover:bg-coral-600 transition-colors text-sm font-medium min-h-[44px]" data-id="element-2590">
                Salva referente
              </button>
            </div>
          </div>
        </div>}
    </MobileLayout>;
}